import { notification } from 'antd';
import getStringsBasedLang from '../../strings/get_strings';
const lang = localStorage.getItem("lang")

export const SuccessMessage = () => {
        notification['success']({
                message: getStringsBasedLang("success"),
                /*  description: */
        })
}

export const CustomSuccessMessage = (msg) => {
        notification['success']({
                message: getStringsBasedLang("success"),
                description: msg
        })
}
export const ErrorMessage = (data) => {
        let msg = ''
        switch (data.error_code) {
                case 114:
                        msg = getStringsBasedLang("name_or_password_wrong")
                        break;
                case 115:
                        msg = getStringsBasedLang("different_email")
                        break;
                case 116:
                        msg = getStringsBasedLang("old_password_wrong")
                        break;
                case 117:
                        msg = getStringsBasedLang("better_password")
                        break;
                case 429:
                        msg = getStringsBasedLang("limitـexceeded")
                        break;
                default:
                        msg = data.error_desc
        }
        notification['error']({
                message: (
                        <div>{getStringsBasedLang("error")}</div>
                ),
                description: (<div className={`${lang === 'en' ? 'englishIranSans' : ''}`}>{msg}</div>)
        })
}
export const CustomErrorMessage = (msg) => {
        notification['error']({
                message: (
                        <div>{getStringsBasedLang("error")}</div>
                ),
                description: (<div className={`${lang === 'en' ? 'englishIranSans' : ''}`}>{msg}</div>)
        })
}